import { memo, useCallback, useEffect, useState } from "react";
import SelectErp from "../../../../components/basics/SelectErp";
const SelectFilter = ({
  setFilter,
  filterOptions,
  filterMatch,
  label,
  disabled,
  disableClearable = true,
  loading,
  placeholder,
  shrink,
}) => {
  const [options, setOptions] = useState([]);

  const getOptionsToList = useCallback((objectOption) => {
    const options = Object.keys(objectOption).map((item) => ({
      description: item,
      value: objectOption[item],
    }));
    return options;
  }, []);

  useEffect(() => {
    if (!options.length && Object.keys(filterOptions).length)
      setOptions(getOptionsToList(filterOptions));
  }, [filterOptions, getOptionsToList, options, setOptions]);

  const getValue = useCallback(
    (listed) => listed?.find((option) => option?.value === filterMatch) || [],
    [filterMatch]
  );

  return (
    <SelectErp
      disabled={disabled}
      disableClearable={disableClearable}
      label={label}
      loading={loading}
      lg={2}
      value={getValue(options)}
      onChange={(option) => {
        setFilter(option?.value);
      }}
      InputLabelProps={{ shrink }}
      optionsList={options}
      descriptionField="description"
      placeholder={placeholder}
    />
  );
};

export default memo(SelectFilter);
